// extracted by mini-css-extract-plugin
module.exports = {"TwoOptionSelector":"TwoOptionsSelector__TwoOptionSelector___qhsp5","SelectorWrapper":"TwoOptionsSelector__SelectorWrapper___12mdb","Active":"TwoOptionsSelector__Active___yt7e1"};